module.exports = __webpack_public_path__ + "static/14-4ada3e8f65fe1cc23ce08fe778878dc5.png";